import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import "./UpdateProfile.css";
import { FiCheck, FiAlertCircle } from "react-icons/fi";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

const isSuccess = (text) =>
  typeof text === "string" && text.toLowerCase().includes("success");

const UpdateProfile = ({ show, closeModal, text }) => {
  const success = isSuccess(text);

  return (
    <Modal
      show={show}
      onHide={closeModal}
      dialogClassName="up-modal md"
      contentClassName="md"
      centered
    >
      {/* ── Header ── */}
      <div className="up-header">
        <ModalCloseButton onClick={closeModal} />
        <div className={`up-icon-ring ${success ? "up-icon-ring--success" : "up-icon-ring--error"}`}>
          {success
            ? <FiCheck size={28} className="up-icon--success" />
            : <FiAlertCircle size={28} className="up-icon--error" />}
        </div>
        <h5 className="up-title">{success ? "Profile Updated!" : "Update Failed"}</h5>
      </div>

      {/* ── Body ── */}
      <div className="up-body">
        <p className="up-message">{text}</p>
      </div>

      {/* ── Footer ── */}
      <div className="up-footer">
        <button
          type="button"
          className={`up-ok-btn ${success ? "" : "up-ok-btn--error"}`}
          onClick={closeModal}
        >
          OK
        </button>
        <p className="up-powered">Powered by Warely</p>
      </div>
    </Modal>
  );
};

UpdateProfile.propTypes = {
  closeModal: PropTypes.func.isRequired,
};
export default UpdateProfile;
